import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@common/checkbox";
import { useExportData } from "@planzone/view-models";
import {
  ExportsDataTypes,
  ExportsFormats,
  Sort as S,
  filter as f,
  project,
} from "@planzone/dto";

import { Props } from "./types";
import { Button } from "@common/button";
import { DateTimeInput } from "@common/dateTimeInput";
import { Filters } from "./filters";
import { Sort } from "./sort";
import styles from "./styles.scss";

function ResourceProjectAllocation(props: Props) {
  const [sort, setSort] = React.useState<S | null>(null);
  const [filter, setFilter] = React.useState(f);
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const { isRequestPending, exportData } = useExportData();
  const [startDate, setStartDate] = React.useState<string | null>(null);

  return (
    <div
      className={classNames(styles.wbsReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("exportReportsPage.resourceProjectAllocationReport.title")}
          </h2>
          <p className={styles.description}>
            {t("exportReportsPage.resourceProjectAllocationReport.subTitle")}
          </p>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.RESOURCE_PROJECT_ALLOCATION_REPORT,
                  data: {
                    planzone: props.planzone,
                    startDate: startDate,
                    filter: filter,
                  },
                },
                format: ExportsFormats.EXCEL,
              });
            }}
          >
            {t("exportReportsPage.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("exportReportsPage.resourceProjectAllocationReport.startDate")}
            </h3>
            <DateTimeInput
              dateTime={startDate ?? ""}
              placeholder={t(
                "exportReportsPage.resourceProjectAllocationReport.startDate",
              )}
              input={setStartDate}
              clear={() => {
                setStartDate(null);
              }}
            />
          </div>
        </div>
      )}
      {isChecked && (
        <div className={styles.filters}>
          <Sort sort={sort} select={setSort} />
          <Filters project={project} filter={filter} setFilter={setFilter} />
        </div>
      )}
    </div>
  );
}

export { ResourceProjectAllocation };
